import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-broadcastings-tv-formats-dashboard',
  templateUrl: './broadcastings-tv-formats-dashboard.component.html',
  styleUrls: ['./broadcastings-tv-formats-dashboard.component.scss']
})
export class BroadcastingsTvFormatsDashboardComponent implements OnInit, OnDestroy {

  noItemsConfig;
  tvFormatDevices;
  getTvFormatDevicesSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
    private broadcastingsService: BroadcastingsService,
    private snackbarService: SnackBarService) {
      this.noItemsConfig = this.setNoItemsConfig();
    }

  ngOnInit() {
    this.getTvFormatDevices();
    this.setBreadcrumb();
  }

  public getTvFormatDevices() {
    this.getTvFormatDevicesSubscription = this.broadcastingsService.getTvFormatDevices().pipe(
      tap(o => this.tvFormatDevices = o),
      catchError(error => { this.tvFormatDevices = '-'; this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th-large', 'broadcastings-page.tvformat', '/broadcastings', [new BRoute('broadcastings-page.broadcastings', '/broadcastings'), new BRoute('broadcastings-page.tvformat')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'broadcastings-page.tv layouts not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getTvFormatDevicesSubscription) { this.getTvFormatDevicesSubscription.unsubscribe(); }
  }
}
